import { render, staticRenderFns } from "./Pfand.vue?vue&type=template&id=047609b9&scoped=true&"
import script from "./Pfand.vue?vue&type=script&lang=js&"
export * from "./Pfand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047609b9",
  null
  
)

export default component.exports